<template>
  <section>
    <stripes/>
    <navigation-side/>
    <main role="main">
      <transition name="fade" mode="out-in">
        <router-view/>
      </transition>
    </main>
    <copyright v-if="footer"/>
    <messenger/>
  </section>
</template>

<script>

import Stripes from '@/components/Template_Stripes'
import NavigationSide from '@/components/Template_Navigation_Side'
import Copyright from '@/components/Template_Copyright'
import Messenger from '@/components/Widget_Messenger'

export default {
  name: 'App',
  components: {
    'stripes': Stripes,
    'navigation-side': NavigationSide,
    'messenger': Messenger,
    'copyright': Copyright
  },
  data () {
    return {
      footer: true
    }
  },
  mounted () {
    if (this.$route.name === 'intro' || this.$route.name === 'root') {
      this.footer = false
    }
  },
  updated () {
    if (this.$route.name === 'intro' || this.$route.name === 'root') {
      this.footer = false
    } else {
      this.footer = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue